import { FC, lazy } from 'react';

import { Customers } from '@/modules/customers';

export const CustomersPage: FC = () => <Customers />;

export const CustomersPageLazy = lazy(async () => {
    const { CustomersPage } = await import('./page');

    return { default: CustomersPage };
});
